import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import getPageTitle from '@/utils/get-page-title'
Vue.use(Router)

const router = new Router({ //创建路由对象
	// mode: 'history',
	routes
})
// 过滤重复路由
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
// 全局前置守卫
router.beforeEach((to, from, next) => {
	// console.log('全局前置守卫')
	// console.log('from',from)
	// console.log('to',to)
	let locationData
	async function locationSelect() {
	    locationData = await getPageTitle()
		document.title = locationData.data.siteName
		document.querySelectorAll("link[rel*='icon']").forEach(item => {
			item.href = locationData.data.siteLogo;
		})
	}
	locationSelect()
	next()
})
// 全局后置钩子
router.afterEach(() => {
    window.scrollTo(0, 0)
})
export default router